export const EC_SURVEYLIST = 'surveyList';
export const EC_QUESTIONLIST = 'questionList';
export const EC_COMBINEDLIST = 'combinedList';
export const EC_SENDMODALCOMBINATION = 'sendModalCombination';
export const EC_STEPTHREELIST = 'stepThreeList';
export const EC_STEPTHREECOMBINEDALTERNATIVES = 'stepThreeCombinedAlternatives'
export const EC_STEPTHREESEPARATEALTERNATIVES = 'stepThreeSeparateAlternatives'
export const EC_DEFAULT = 'default'
